'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _markerclusterer = require('@googlemaps/markerclusterer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[Map]');

var WinresReservationMapController = function () {
    function WinresReservationMapController($scope, $rootScope, $timeout, productService, localizationService, destinationService, internetClassificationService, departureService, $filter, ownerService, $compile) {
        _classCallCheck(this, WinresReservationMapController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.map = null;
        this.places = [];
        this.lat = 1.0;
        this.lng = 2.0;
        this.productService = productService;
        this.localizationService = localizationService;
        this.DestinationService = destinationService;
        this.internetClassificationService = internetClassificationService;
        this.departureService = departureService;
        this.$filter = $filter;
        this.ownerService = ownerService;
        this.panMap = true;
        this.markers = [];
        this.noImageMarkers = []; // markers without image pop-up + temp markers.
        this.markerFilter = [];
        this.zoomLevel = 10;
        this.panLatLng = { lat: 0, lng: 0, zoom: 0, selectedMapId: 0 };
        this.loadingMap = false;
        this.loadingMarkers = false;
        this.valid = false; //
        this.hotelValid = false; //
        this.days = 0;
        this.useSeo = false;
        this.infoRect = { rect: null };
        this.$compile = $compile;
        this.markerClusterer = null;
    }

    _createClass(WinresReservationMapController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.mapId || this.mapId == "") this.mapId = "reservation-map"; // default template element id.

            // log("Init. Map id='" + this.mapId + "'");

            this.hasGoogle = 'google' in window && (typeof google === 'undefined' ? 'undefined' : _typeof(google)) === 'object' && _typeof(google.maps) === 'object';
            if (!this.hasGoogle) {
                log.warn("Google is", window['google']);
                return;
            }

            // Google chrome automatic map updater.
            // var isChrome = !!window.chrome && !!window.chrome.webstore;
            // if(isChrome){
            //     var winres = this;
            //     var hasTimeout = false;
            //     window.onclick = ()=>{
            //         if(hasTimeout==true) return;
            //         setTimeout(()=>{
            //             hasTimeout = false;
            //             if(winres.map){
            //                 var map = winres.map.mapElement;
            //                 if(map) map.parentNode.appendChild(map);
            //             }
            //         }, 1000);
            //         hasTimeout = true;
            //     };
            // }

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().DestinationCode
            // getContext().SelectedDeparture
            // getSeoState()
            // getOwnerData()

            // Set:

            // Other:

            this.data = this.winresReservationContext.getContext();
            this.useSeo = this.winresReservationContext.getSeoState();

            //this.hotelValid = false;

            this.$scope.$watch('$ctrl.data.Destination', function () {
                if (_this.hotelLocation == "true") return;
                _this.Destination = _this.data.Destination;
                if (!_this.data.Destination || !_this.data.Destination.Latitude || !_this.data.Destination.Longitude) {
                    _this.valid = false;
                    return;
                }
                _this.lat = _this.convertCoordinates(_this.data.Destination.Latitude);
                _this.lng = _this.convertCoordinates(_this.data.Destination.Longitude);

                // console.log("[map] lat " + this.lat + " lng " + this.lng);

                _this.places = [];
                if (_this.loadingMap == false && _this.lat && _this.lng) {
                    _this.loadingMap = true;
                    _this.initMap(_this.lat, _this.lng).then(function () {
                        if (_this.DestinationMarker) {
                            _this.DestinationMarker.setMap(null);
                            _this.DestinationMarker = null;
                        }
                        var departure = { Destination: _this.Destination };

                        var result = { isDestinationMarker: true, departure: departure,
                            name: _this.Destination.DestinationName, lat: _this.lat, lng: _this.lng,
                            code: _this.Destination.DestinationCode, isDeparture: true, bounds: true };
                        result.departure.Rating = 0;
                        result.departure.ReservationLink = "";
                        result.departure.Price = "0";

                        _this.initMapArray([result]);
                    }).catch(function (error) {
                        console.error("[map]", error);
                    });
                }
            });

            if (this.hotelLocation == "true") {
                this.$scope.$watch('$ctrl.data.SelectedDeparture', function (newDeparture) {
                    // load map.
                    if (_this.loadingMap == false && newDeparture != null) {
                        _this.loadingMap = true;
                        _this.loadingMarkers = true;
                        if (!_this.map) {
                            _this.panMap = true;
                            var latLng = _this.getLatlng();
                            _this.initMap(latLng.lat(), latLng.lng()).then(function (map) {
                                if (map) _this.fetchRoomProducts();else console.warn("[map] initMap failed.");
                            }).catch(function (error) {
                                console.error("[map]", error);
                            });
                        } else {
                            // set new hotel markers.
                            // console.log("[map] search new hotels. id='"+this.mapId+"'");
                            _this.reset();
                            _this.panMap = true;
                            _this.fetchRoomProducts();
                        }
                    }
                });
            }

            if (this.departureMap === "true") {
                if (this.loadingMap == false) {
                    this.loadingMap = true;
                    this.loadingMarkers = true;
                    if (!this.map) {
                        this.panMap = true;
                        var latLng = this.getLatlng();
                        this.initMap(latLng.lat(), latLng.lng()).then(function (map) {
                            if (map) {
                                _this.getClassifications();
                                _this.getMapDestinations();
                            } else console.warn("[map] initMap failed.");
                        }).catch(function (error) {
                            console.error("[map]", error);
                        });
                    } else {
                        this.reset();
                        this.panMap = true;
                        this.getClassifications();
                        this.getMapDestinations();
                    }
                }
            }

            if (this.useOwnerData === 'true') {
                this.winresReservationContext.getOwnerData().then(function (data) {
                    var lat = data.Latitude.substring(0, data.Latitude.length - 1);
                    var lng = data.Longitude.substring(0, data.Longitude.length - 1);

                    _this.lat = _this.convertCoordinates(lat);
                    _this.lng = _this.convertCoordinates(lng);

                    if (_this.loadingMap == false) {
                        _this.loadingMap = true;
                        _this.initMap(_this.lat, _this.lng).then(function () {
                            if (_this.DestinationMarker) {
                                _this.DestinationMarker.setMap(null);
                                _this.DestinationMarker = null;
                            }
                            /*var result = {isDestinationMarker:true, name:data.Company, lng:lng, lat:lat}
                            this.initMapArray([result]);*/
                            var producer = data;
                            var destinationInfo = { ProductName: data.Company };
                            var departure = { Producer: producer, DestinationInfo: destinationInfo };
                            var result = { isDestinationMarker: true, departure: departure, name: data.Company,
                                lng: lng, lat: lat, isHotel: true, bounds: true };
                            _this.initMapArray([result]);
                        }).catch(function (error) {
                            console.error("[map]", error);
                        });
                    }
                });
            }

            // Pan map when this.panLatLng changes.
            //this.$scope.$watch('$ctrl.panLatLng', (newPanLatLng) => {
            if (this.watchLatLng) {
                this.$scope.$on("setLatLng", function (event, newPanLatLng) {
                    var latLng = newPanLatLng;
                    _this.panLatLng = latLng;
                    if (!latLng) return;
                    if (latLng.zoom == 0) return;

                    _this.updateMap(_this.getMapParent(_this.mapId + "-anchor", latLng.selectedMapId), _this.map.mapElement);
                    _this.panChanged(latLng);

                    if (_this.infoWindowsOpen) _this.openInfoWindows(); // Open pop-up for every marker.
                });
            }

            if (this.departureMap === "true" || this.hotelLocation == "true") {
                if (this.searchCriteria) {
                    var startDate = new Date(this.searchCriteria.StartDate);
                    var endDate = new Date(this.searchCriteria.EndDate);
                    this.days = Math.floor((endDate - startDate) / 86400000); // (24*60*60*1000)
                }
            }

            if (this.departureMap === "true") {
                this.$scope.$watch("$ctrl.activeFilters", function (newValue, oldValue) {
                    if (!_this.map) return;
                    // Filter by search terms when search button is pressed.
                    if (oldValue.searchFieldTerm == newValue.searchFieldTerm || oldValue.searchFieldTerm == newValue.searchTerms[newValue.searchTerms.length - 1]) _this.filterMarkers(_this.markers); // Filter markers.
                }, true); // true = detect object changes.
            }
            this.createInfoWindows();
        }
    }, {
        key: 'filterMarkers',
        value: function filterMarkers(markers, noImage) {
            var _this2 = this;

            return; // Markers are now filtered by DestinationFilter component and passed as filteredResults for the map

            // Set all markers invisible.
            _.each(markers, function (marker) {
                if (!marker.isDestinationMarker && !marker.temp) marker.setVisible(false);
            });

            this.closeInfoWindow();
            this.selectedMarker = null;

            console.log(this.activeFilters);

            var filteredMarkers = markers;
            if (this.activeFilters && !noImage) // no image markers break combined filter, filter them separately.
                filteredMarkers = this.$filter('combinedFilter')(markers, this.activeFilters); // searchFilter.js

            // Filter markers again by classification.
            var bounds = new google.maps.LatLngBounds();
            var len = 0;
            _.each(filteredMarkers, function (marker) {
                if (_this2.hasClassification(marker.clas) && !marker.temp) {
                    marker.setVisible(true); // Set filtered markers visible.
                    if (_this2.panMap == true && !noImage) bounds.extend(marker.position);
                    /*if(marker.infoWindow && this.selectedMarker==marker){
                        marker.infoWindow.open(this.map, marker);
                    }*/
                    len++;
                }
            });

            if (this.panMap == true && len > 0 && !noImage) this.centerMapByBounds(bounds);

            console.log(this.markers, this.noImageMarkers);

            // Filter no image markers.
            if (!noImage && this.noImageMarkers.length > 0) {
                this.filterMarkers(this.noImageMarkers, true);
            } else {
                if (this.markerClusterer) {
                    this.resetMarkerClusters();
                }
            }
        }
    }, {
        key: 'openInfoWindows',
        value: function openInfoWindows() {
            var _this3 = this;

            var markers = this.markers;
            markers.concat(this.noImageMarkers);
            this.$timeout(function () {
                return _.each(markers, function (marker) {
                    return _this3.openInfoWindow(marker, false, marker.name, true);
                });
            }, 250);
        }
    }, {
        key: 'panChanged',
        value: function panChanged(latLng) {
            this.panMap = false;
            this.stopZoom = true;

            var lat = this.convertCoordinates(latLng.lat);
            var lng = this.convertCoordinates(latLng.lng);
            var zoom = latLng.zoom;

            if (lat != 0 && lng != 0) this.panMapTo(lat, lng, zoom);
        }
    }, {
        key: 'getLatlng',
        value: function getLatlng() {
            if (this.panLatLng.zoom != 0) return new google.maps.LatLng(this.panLatLng.lat, this.panLatLng.lng); // Lat and lng from panLatLng.
            return new google.maps.LatLng(60.176991, 24.949120); // Helsinki.
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.valid = false; //
            this.hotelValid = false; //
            this.deleteAllMarkers();
            if (this.places.length > 0) this.places.splice(0, this.places.length);
        }
    }, {
        key: 'allMarkers',
        value: function allMarkers() {
            return this.markers.concat(this.noImageMarkers);
        }
    }, {
        key: 'deleteAllMarkers',
        value: function deleteAllMarkers() {
            this.closeInfoWindow();
            this.selectedMarker = null;
            var markers = this.allMarkers();
            if (markers.length > 0) {
                _.each(markers, function (marker) {
                    return marker.setMap(null);
                });
                this.markers.splice(0, this.markers.length);
                this.noImageMarkers.splice(0, this.noImageMarkers.length);
            }

            if (this.markerClusterer) {
                this.markerClusterer.setMap(null);
                this.markerClusterer = null;
            }

            if (this.map) google.maps.event.clearListeners(this.map.mapObject, "click"); // Remove all click listeners.
        }

        // Called when search criteria is changed.

    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (this.map && this.departureMap === "true") {
                // console.log("[map]: updated search criteria:", this.searchCriteria);

                this.reset();
                this.panMap = true; // Pan map near markers.

                //this.getClassifications();
                this.getMapDestinations();
            }
        }

        // Set classifications.

    }, {
        key: 'setClassification',
        value: function setClassification() {
            this.panMap = true;
            this.filterMarkers(this.markers);
        }
    }, {
        key: 'hasClassification',
        value: function hasClassification(clas) {
            if (!clas) return true;
            var result = false;
            _.each(this.internetClas, function (clas1) {
                _.each(clas, function (clas2) {
                    if (clas2 && clas1.code == clas2.Code && clas1.checked == true) result = true;
                });
            });
            return result;
        }
    }, {
        key: 'getClassifications',
        value: function getClassifications() {
            var _this4 = this;

            this.internetClassificationService.loadInternetClassifications().then(function (types) {
                _this4.internetClas = [];
                _.each(types, function (internetClassification) {
                    if (!internetClassification.Value) internetClassification.Value = true; // enable checkboxes by default.
                    _this4.internetClas.push({ code: _this4.useSpecificClassification || internetClassification.Code,
                        name: internetClassification.Name, checked: internetClassification.Value });
                });
            });
        }
    }, {
        key: 'getMapDestinations',
        value: function getMapDestinations() {
            var _this5 = this;

            if (this.destinationsToMap != null && this.destinationsToMap.length > 0) {
                this.displayDestinationsOnMap(this.destinationsToMap);
            } else {
                var language = this.localizationService.getLanguage();
                this.DestinationService.getMapDestinations(this.onlyFutureDepartures, language).then(function (destinations) {
                    _this5.destinations = destinations;
                    _this5.destinationsToMap = [];
                    _.each(_this5.destinations, function (destination) {
                        _this5.destinationsToMap.push({ lat: _this5.convertCoordinates(destination.Latitude),
                            lng: _this5.convertCoordinates(destination.Longitude), name: destination.Name, code: destination.Destination });
                    });
                    _this5.displayDestinationsOnMap(_this5.destinationsToMap);
                });
            }
        }
    }, {
        key: 'displayDestinationsOnMap',
        value: function displayDestinationsOnMap(destinations) {
            var _this6 = this;

            this.destinations = destinations;

            // filter destinations
            var filteredDestinations = [];

            /*
            _.each(this.destinations, destination => {
                //console.log(destination);
                //console.log("INTERNETCLASS", this.internetClas);		
                if(destination.lat!=0 && destination.lng!=0 && 
                _.find(this.internetClas, { 'code': destination.intClas, 'checked': true }) != null){
            filteredDestinations.push(destination);
                };
            });
              if(filteredDestinations && filteredDestinations.length<=0){
                console.warn("[map] filteredDestinations length is", filteredDestinations.length);
                if(!this.destinationReloadTimes)
                    this.destinationReloadTimes = 0;
                this.destinationReloadTimes++;
                if(this.destinationReloadTimes>8){ // iterate max 8 times.
                    console.error("[map] no destinations.")
                    return;
                }
                this.getMapDestinations(); // try iterate again.
                return;
            }
            */
            this.filteredDestinations = destinations; // filteredDestinations;

            var searchCriteria = this.searchCriteria;
            if (!searchCriteria) console.warn("[map] search criteria is", searchCriteria);

            var language = this.localizationService.getLanguage();
            var reserveLink = true;
            if (this.withReserveLink === "false") reserveLink = false;

            // console.log("[map] search departures.");

            var data = [];
            _.each(this.filteredResults, function (result) {
                var filteredDestination = _.find(_this6.filteredDestinations, function (filteredDestination) {
                    return result.Destination.DestinationCode == filteredDestination.code;
                });

                if (!filteredDestination) {
                    return;
                }

                var departure = {
                    departure: result, name: result.Destination.DestinationName, lng: filteredDestination.lng, lat: filteredDestination.lat,
                    code: result.Destination.DestinationCode,
                    isDeparture: true, temp: false,
                    noImage: result.Destination.Images.length == 0, bounds: true
                };

                data.push(departure);
            });
            this.initMapArray(data);

            return;

            // Marker pop-up loading at background.

            // Markers if no search criteria.
            // Search markers one by one.
            // (searchReservableItems spam in network tab)
            var idx = 0;
            if (!searchCriteria) {
                _.each(filteredDestinations, function (filteredDestination) {
                    _this6.departureService.searchReservableItems({ DestinationCodes: [filteredDestination.code], Limit: 1 }, reserveLink, language).then(function (departure) {
                        var result = { departure: departure.Results[0], name: filteredDestination.name, lng: filteredDestination.lng,
                            lat: filteredDestination.lat, code: filteredDestination.code, isDeparture: true, temp: false };
                        if (result.departure) {
                            result.clas = result.departure.Destination.InternetClassifications;
                            _this6.addMarker(result, _this6.map.mapObject); // delayed markers.
                        } else {
                            console.warn("[map] result.departure is", result.departure, filteredDestination.name, filteredDestination.code);

                            var result = { name: filteredDestination.name, lng: filteredDestination.lng,
                                lat: filteredDestination.lat, code: filteredDestination.code, clas: [{ Code: filteredDestination.intClas }],
                                noImage: true, temp: false };
                            _this6.addMarker(result, _this6.map.mapObject); // marker with name only.
                        }
                        idx++;
                        if (idx >= filteredDestinations.length) _this6.removeTempMarkers();
                    });
                });
            } else {
                // Markers if has search criteria.
                this.fetchReservableItems(searchCriteria, reserveLink, language, 0); // Iterate first 50 markers.
                //this.removeTempMarkers()
            }
        }
    }, {
        key: 'fetchReservableItems',
        value: function fetchReservableItems(searchCriteria, reserveLink, language, offset) {
            var _this7 = this;

            var copyCriteria = JSON.parse(JSON.stringify(searchCriteria));
            copyCriteria.Offset = offset;
            // console.log("[map] fetch items. offset:", copyCriteria.Offset);
            this.departureService.searchReservableItems(copyCriteria, reserveLink, language).then(function (departure) {
                if (departure.HasMore == true) {
                    _this7.fetchReservableItems(searchCriteria, reserveLink, language, offset + 50);
                }
                _.each(departure.Results, function (result, idx) {
                    var product = result.Product;
                    if (product) {
                        var lat = _this7.convertCoordinates(product.DestinationInfo.Latitude);
                        var lng = _this7.convertCoordinates(product.DestinationInfo.Longitude);
                        if (lat != 0 && lng != 0) {
                            /*
                            var departure = {
                                departure:result, name:result.Destination.DestinationName, lng:lng, lat:lat, 
                                code:product.DestinationInfo.DestinationCode, 
                                clas:result.Destination.InternetClassifications, isDeparture:true, temp: false,
                                noImage: result.Destination.Images.length == 0, bounds: true
                            };
                            */

                            result.isDeparture = true;
                            result.departure = result;

                            var foundIndex = _this7.noImageMarkers.findIndex(function (noImageMarker) {
                                return noImageMarker.code == product.DestinationInfo.DestinationCode;
                            });
                            if (foundIndex != -1) {
                                var marker = _this7.noImageMarkers[foundIndex];

                                marker.temp = false;
                                marker = _this7.setMarkerData(result, marker); // replace marker contents.
                                _this7.noImageMarkers.splice(foundIndex, 1); // remove from no image markers array.
                                _this7.markers.push(marker); // add marker to default marker array.
                                console.log("Moved ", marker.code, " to markers");
                            } else {
                                var _marker = _this7.addMarker(result, _this7.map.mapObject);
                            }
                        }
                    } else console.warn("[map] result.Product is", product, idx);
                });

                if (departure.HasMore == false) _this7.removeTempMarkers();
            });
        }
    }, {
        key: 'fetchRoomProducts',
        value: function fetchRoomProducts() {
            var _this8 = this;

            // console.log("[map] search room products.");
            if (!this.data.SelectedDeparture) console.warn("[map] this.data.SelectedDeparture is", this.data.SelectedDeparture);
            var places = [];
            if (angular.isObject(this.data.SelectedDeparture)) {
                var type = null;
                switch (this.type) {
                    case 'RO':
                        type = 'room'; // unsure if RO.
                        break;
                    case 'HY':
                        type = 'cabin';
                        break;
                    case 'OK':
                        type = 'common';
                        break;
                    default:
                        type = null;
                }
                this.productService.getReservableProductsGroupedByProducer({
                    DestinationCode: this.data.DestinationCode,
                    StartDate: this.data.SelectedDeparture.DepartureDate,
                    EndDate: this.data.SelectedDeparture.ArrivalDate2,
                    MinCapacity: 0,
                    ProductType: type
                    //ProductType: this.type == 'HY' ? 'cabin' : 'room' // to do: add this.type // Old behavior.
                }, this.localizationService.getLanguage()).then(function (hotels) {
                    _this8.hotels = hotels;
                    _.each(_this8.hotels, function (hotel) {
                        var name = "";
                        if (hotel.Producer) name = hotel.Producer.Company;
                        if (!hotel.Producer) {
                            var codes = [];
                            // Destination codes without Producer.
                            _.each(hotel.Products, function (product) {
                                return codes.push(product.DestinationInfo.DestinationCode);
                            });
                            console.warn("[map] hotel.Producer is", hotel.Producer, codes);
                        }
                        // Add hotel products.
                        _.each(hotel.Products, function (product) {
                            return places.push(_this8.addHotel(product, name));
                        });

                        // Add hotel producer.
                        //places.push(this.addHotel(hotel.Producer, name));
                    });
                    places = _.filter(places, function (place) {
                        return place != null;
                    }); // filter null places off.
                    _this8.places = _this8.places.concat(places);

                    _this8.initMapArray(_this8.places);
                    //if(this.noImageMarkers.length>0)
                    //    console.warn("[map] markers without image pop-up:", this.noImageMarkers.length)
                });
            }
        }
    }, {
        key: 'addHotel',
        value: function addHotel(hotel, name) {
            var noImage;
            if (name == "") {
                //name = hotel.DestinationInfo.DestinationName;
                name = hotel.DestinationInfo.ProductName;
                noImage = true;
                //console.warn("[map] spawn marker without image pop-up", name, 
                //              product.DestinationInfo.DestinationCode);
            }

            var lat = this.convertCoordinates(hotel.DestinationInfo.Latitude);
            var lng = this.convertCoordinates(hotel.DestinationInfo.Longitude);

            if (lat != 0 && lng != 0) {
                var htl = { departure: hotel, lat: lat, lng: lng, name: name,
                    code: hotel.DestinationInfo.DestinationCode, isHotel: true, noImage: noImage,
                    bounds: true };
                this.hotelValid = true;
                return htl;
            }
            return null;
        }
    }, {
        key: 'panMapTo',
        value: function panMapTo(lat, lng, zoom) {
            if (this.map) {
                var map = this.map.mapObject;
                map.panTo(new google.maps.LatLng(lat, lng));
                var maxZoom = parseInt(this.zoomLevel) || 10;
                if (zoom >= maxZoom) zoom = maxZoom;
                map.setZoom(zoom);
            }
        }
    }, {
        key: 'getHotelInfoWindowTemplate',
        value: function getHotelInfoWindowTemplate(info) {
            var template = document.createElement("div");
            template.innerHTML = '<div class="map-info-window-close-x" ng-click="$ctrl.shouldCloseInfoWindow()"></div>' + '<div class="map-info-window-container">' + '<img class="map-info-window-image" src=' + info.img + '>' + '<div class="map-info-window-header-container">' + '<p class="map-info-window-header">' + info.name + '</p>' + '</div>' + '<div class="map-info-window-hotel-content">' + '<p class="map-info-window-info">' + info.note1 + '</p>' + '<p class="map-info-window-info">' + info.note2 + '</p>' + '<p class="map-info-window-info">' + info.note3 + '</p>' + '<p class="map-info-window-info">' + info.note4 + '</p>' + '</div>' + '</div>';
            this.$compile(template)(this.$scope); // Compile ng-click.
            return template;
        }
    }, {
        key: 'getDepartureInfoWindowTemplate',
        value: function getDepartureInfoWindowTemplate(info) {
            var template = document.createElement("div");
            template.className = "map-info-card";

            var innerHTML = '<div>' + '<div class="map-info-window-close-x" ng-click="$ctrl.shouldCloseInfoWindow()"></div>' + '<div class="map-info-window-container">' + '<img class="map-info-window-image" src="' + info.img + '">' + '<div class="map-info-window-header-container">' + '<p class="map-info-window-header">' + info.name + '</p>' + '</div>' + '<div class="map-info-window-departure-content">' + '<p class="map-info-window-info">' + info.description + '<br/> <p style="color: #f00; font-size: 13px;">' + info.priceNote + '</p>' + '</p>';
            if (info.hasStars) {
                _.each(info.stars, function (star) {
                    innerHTML = innerHTML + '<div style="display: inline;">';
                    if (star.type == 0) innerHTML = innerHTML + '<i class="' + star.class + '" style="font-size: 16px; opacity:0.33;"></i>';
                    if (star.type == 1) innerHTML = innerHTML + '<i class="' + star.class + '" style="font-size: 16px;"></i>';
                    innerHTML = innerHTML + '</div>';
                });
            }
            innerHTML = innerHTML + "</div>";
            if (info.price && info.price > 0 || info.url && info.url != "") {
                innerHTML = innerHTML + '<div class="map-info-window-footer">';
                if (info.price && info.price > 0) {
                    innerHTML = innerHTML + '<div class="map-info-window-price-container">';
                    if (info.days > 0) innerHTML = innerHTML + '<span class="map-info-window-days" ng-i18next>[i18next]({ count: ' + info.days + ' })map.price_for_n_nights</span><br>';else innerHTML = innerHTML + '<span class="map-info-window-days" ng-i18next>common.price</span><br>';
                    innerHTML = innerHTML + '<span class="map-info-window-price-a" ng-i18next>map.price_from</span> <span class="map-info-window-price">' + info.price + '€</span>' + '</div>';
                }
                if (info.url && info.url != "") {
                    if (info.isReservable) innerHTML = innerHTML + '<a class="map-info-window-button" target="' + this.infoWindowLinkTarget() + '" href="' + info.url + '" ng-i18next>map.book</a>';else innerHTML = innerHTML + '<a class="map-info-window-button" target="' + this.infoWindowLinkTarget() + '" href="' + info.url + '" style="width: auto;" ng-i18next>map.view</a>';
                }

                innerHTML = innerHTML + '</div>';
            }
            innerHTML = innerHTML + '</div>' + '</div>';
            template.innerHTML = innerHTML;
            this.$compile(template)(this.$scope); // Compile ng-click.
            return template;
        }
    }, {
        key: 'infoWindowLinkTarget',
        value: function infoWindowLinkTarget() {
            return this.reserveInNewWindow == "true" ? "_blank" : "_self";
        }
    }, {
        key: 'createInfoWindows',
        value: function createInfoWindows() {
            var _this9 = this;

            // Map info window class.
            var MapInfoRect = function MapInfoRect(position, template) {
                this.init = function (position, template) {
                    this.position = position;
                    this.hide = false;

                    this.x = 0;
                    this.y = 0;

                    this.anchor = template;
                    this.anchor.className = "map-info-window";
                };
                this.init(position, template);
                this.getPos = function () {
                    return [this.x, this.y];
                };
            };

            MapInfoRect.prototype = Object.create(google.maps.OverlayView.prototype);
            MapInfoRect.prototype.onAdd = function () {
                var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                this.x = divPosition.x;
                this.y = divPosition.y;
                this.getPanes().floatPane.appendChild(this.anchor);
            };
            MapInfoRect.prototype.onRemove = function () {
                if (this.anchor.parentElement) {
                    this.anchor.parentElement.removeChild(this.anchor);
                }
            };
            MapInfoRect.prototype.draw = function () {
                var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';
                if (display === 'block') {
                    // Used to move template info window element.
                    this.anchor.style.left = divPosition.x + 'px';
                    this.anchor.style.top = divPosition.y + 'px';

                    // Used for getPos, which is used to detect infoWindow overflow.
                    this.x = divPosition.x;
                    this.y = divPosition.y;
                }
                if (this.anchor.style.display !== display && this.hide == false) {
                    this.anchor.style.display = display;
                }
            };

            this.infoWindow = new google.maps.InfoWindow(); // Default info window (speech bubble).
            this.infoRect = { rect: null };
            this.infoRect.selectedMarker = null;
            this.selectedMarker = null;

            this.infoRect.open = function () {
                _this9.infoRect.rect.hide = false;
                _this9.infoRect.rect.anchor.style.display = "block";
            };

            this.infoRect.close = function () {
                _this9.infoRect.rect.hide = true;
                _this9.infoRect.rect.anchor.style.display = "none";
            };

            this.infoRect.panMapIfOverflow = function () {
                setTimeout(function () {
                    var pos = _this9.infoRect.rect.getPos();
                    var map = _this9.map.mapObject;
                    var mapElement = _this9.map.mapElement;
                    var mapWidth = mapElement.clientWidth;
                    var mapHeight = mapElement.clientHeight;

                    var rectWidth = 500;
                    var rectHeight = _this9.infoRect.rect.anchor.clientHeight;
                    if (rectHeight <= 500) rectHeight = 318;
                    rectWidth -= 64;
                    if (mapWidth <= 600) {
                        rectWidth = rectWidth * 0.5;
                        rectHeight = rectHeight * 0.5;
                    }
                    rectWidth += 64;
                    rectHeight += 16;

                    var addX = mapWidth * 0.5 - rectWidth;
                    var addY = rectHeight - mapHeight * 0.5;
                    if (pos[0] > addX) map.panBy(pos[0] - addX, 0); // x
                    if (pos[1] > -addY) map.panBy(0, addY + pos[1]); // y
                }, 100);
            };

            this.openInfoWindow = function (marker, html, content, noSelect) {
                var map = _this9.map.mapObject;
                if (html == true) {
                    if (marker.infoRect) _this9.infoRect.rect = marker.infoRect;else {
                        _this9.infoRect.rect = new MapInfoRect(new google.maps.LatLng(marker.position.lat(), marker.position.lng()), content);
                        _this9.infoRect.rect.setMap(map);
                        _this9.infoRect.rect.marker = marker;
                        marker.infoWindow = _this9.infoRect;
                        marker.infoRect = _this9.infoRect.rect;
                    }
                    _this9.infoRect.open();
                    _this9.infoRect.panMapIfOverflow();
                } else {
                    _this9.infoWindow.setContent(content); // text.
                    _this9.infoWindow.open(map, marker);
                    marker.infoWindow = _this9.infoWindow;
                }
                if (!noSelect) {
                    marker.setOpacity(0.5); // Marker info opened.
                    marker.setZIndex(999);
                }
                //marker.html = html;
                //marker.content = content;
                _this9.selectedMarker = marker;
            };

            this.closeInfoWindow = function () {
                if (_this9.infoRect.rect) _this9.infoRect.close();
                _this9.infoWindow.close();
            };

            this.shouldCloseInfoWindow = function (marker) {
                if (marker && marker.infoWindow) {
                    marker.infoWindow.close();
                    marker.infoWindow = null;
                    marker.setOpacity(1.0); // deselect marker.
                    marker.setZIndex(marker.ZIndex);
                }

                if (_this9.selectedMarker) {
                    _this9.closeInfoWindow();
                    _this9.selectedMarker.setOpacity(1.0); // deselect marker.
                    _this9.selectedMarker.setZIndex(_this9.selectedMarker.ZIndex);
                }
                var stop = false;
                if (_this9.selectedMarker && marker == _this9.selectedMarker) stop = true;
                _this9.selectedMarker = null;
                return stop;
            };
            this.infoRect.MapInfoRect = MapInfoRect;
        }
    }, {
        key: 'centerMapByBounds',
        value: function centerMapByBounds(bounds) {
            if (!bounds) bounds = this.bounds;

            var map = this.map.mapObject;
            var zoom = parseInt(this.zoomLevel) || 10;

            map.setOptions({ maxZoom: zoom }); // Lock maxZoom for a second.
            map.fitBounds(bounds); // Fit map middle of markers.
            this.$timeout(function () {
                return map.setOptions({ maxZoom: null });
            }, 1500); // Unlock maxZoom.

            var currentZoom = map.getZoom();
            if (currentZoom >= zoom) map.setZoom(zoom);

            if (this.mapTilesLoaded) return;
            var winres = this;
            var tilesListener = google.maps.event.addListener(map, "tilesloaded", function () {
                if (winres.panLatLng.zoom == 0) {
                    // no hotel mini map bound fitting.
                    map.setOptions({ maxZoom: zoom }); // Lock maxZoom for a second.
                    map.fitBounds(bounds);
                    winres.$timeout(function () {
                        return map.setOptions({ maxZoom: null });
                    }, 1500); // Unlock maxZoom.
                }
                var currentZoom = map.getZoom();
                if (currentZoom <= 1) map.fitBounds(bounds); // fix max zoom out bug.
                if (!winres.stopZoom && currentZoom >= zoom) map.setZoom(zoom);
                if (winres.infoWindowsOpen) winres.openInfoWindows(); // Open pop-up for every marker.
                google.maps.event.removeListener(tilesListener);
            });
            this.mapTilesLoaded = true;

            //map.parentNode.appendChild(map);
            //clearInterval(mapUpdater);
        }
    }, {
        key: 'removeTempMarkers',
        value: function removeTempMarkers() {
            var _this10 = this;

            _.each(this.noImageMarkers, function (marker) {
                if (marker.temp) {
                    // Move info window pop-up from temp marker to real marker.
                    if (_this10.selectedMarker == marker) {
                        _this10.closeInfoWindow();
                        var infoWindowMarkers = _.filter(_this10.markers, function (marker2) {
                            return marker2.code == _this10.selectedMarker.code;
                        });
                        _this10.selectedMarker = null;
                        if (infoWindowMarkers[0]) {
                            var iMarker = infoWindowMarkers[0];
                            _this10.openInfoWindow(iMarker, iMarker.html, iMarker.content);
                        }
                    }
                    marker.setMap(null);
                }
            });
            this.noImageMarkers = _.filter(this.noImageMarkers, function (marker) {
                return !marker.temp;
            });
            //this.filterMarkers(this.markers)
        }
    }, {
        key: 'initMapArray',
        value: function initMapArray(results) {
            var _this11 = this;

            if (!google) {
                console.error("[map] google element does not exist!");
                return;
            }
            var map = this.map;

            // console.log("[map] initializing markers. map id='"+map.id+"'");

            if (this.searchCriteria) {
                var startDate = new Date(this.searchCriteria.StartDate);
                var endDate = new Date(this.searchCriteria.EndDate);
                this.days = Math.floor((endDate - startDate) / 86400000); // (24*60*60*1000)
            }

            var googleMap = this.map.mapObject; // real google map.

            this.bounds = new google.maps.LatLngBounds();
            _.each(results, function (result) {
                var marker = _this11.addMarker(result, googleMap);
                if (result.bounds) _this11.bounds.extend(marker.position); // map fitting bounds.
            });
            this.loadingMarkers = false;

            //if(this.activeFilters) this.filterMarkers(this.markers); // Filter spawned markers.

            if (this.panMap == true) {
                this.centerMapByBounds();
                this.panMap = false;
            }

            if (this.infoWindowsOpen) this.openInfoWindows(); // Open pop-up for every marker.

            // console.log("%c[map] markers initialized.%c", "color: rgb(0,100,0)");
            var markers = this.markers;
            markers = markers.concat(this.noImageMarkers);
            if (markers.length <= 0 && !this.DestinationMarker) {
                console.error("[map] no markers!");
                this.valid = false; // hide map.
            } else {
                this.$rootScope.$broadcast("show-map-icon", this.mapId); // Show possible mini map icon if markers.
                this.initMarkerClusterer(markers, googleMap);
            }

            this.loadingMap = false;
        }
    }, {
        key: 'markerClustererRenderer',
        value: function markerClustererRenderer() {
            function clusterMarkerColor(count) {
                if (count > 100) return "#f01e13"; // red
                if (count > 10) return "#fae739"; // yellow

                return "#008CFF"; // blue
            }

            var renderer = {
                render: function render(_ref) {
                    var count = _ref.count,
                        position = _ref.position;


                    var color = clusterMarkerColor(count);

                    var svg = window.btoa('\n                <svg fill="' + color + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">\n                <circle cx="120" cy="120" opacity="1" r="70" />\n                <circle cx="120" cy="120" opacity=".3" r="90" />\n                <circle cx="120" cy="120" opacity=".2" r="110" />\n                <circle cx="120" cy="120" opacity=".1" r="130" />\n                </svg>');

                    return new google.maps.Marker({
                        position: position,
                        icon: {
                            url: 'data:image/svg+xml;base64,' + svg,
                            scaledSize: new google.maps.Size(45, 45)
                        },
                        label: {
                            text: String(count),
                            color: "black",
                            fontSize: "12px"
                        },
                        // adjust zIndex to be above other markers
                        zIndex: 1000 + count
                    });
                }
            };

            return renderer;
        }
    }, {
        key: 'resetMarkerClusters',
        value: function resetMarkerClusters() {
            this.markerClusterer.setMap(null);
            this.markerClusterer = null;

            var markers = this.allMarkers();

            if (markers.length == 0) return;

            this.initMarkerClusterer(markers, this.map.mapObject);
        }
    }, {
        key: 'initMarkerClusterer',
        value: function initMarkerClusterer(markers, googleMap) {
            var _this12 = this;

            if (!this.markerClusterer) {
                this.markerClusterer = new _markerclusterer.MarkerClusterer({
                    "markers": markers,
                    "map": googleMap,
                    "renderer": this.markerClustererRenderer(),
                    "onClusterClick": function onClusterClick(event, cluster, map) {
                        _this12.shouldCloseInfoWindow();

                        map.fitBounds(cluster.bounds);
                        var maxZoom = _this12.markerClusterer.algorithm.maxZoom;
                        if (map.getZoom() > maxZoom) map.setZoom(maxZoom + 1);
                    }
                });
            } else {
                this.resetMarkerClusters();
            }
        }
    }, {
        key: 'addMarker',
        value: function addMarker(result, map) {
            //if(result.noImage) return;
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(result.lat, result.lng),
                icon: this.markerSvgSymbol()
            });

            if (map) marker.setMap(map);
            if (!this.DestinationMarker && result.isDestinationMarker) this.DestinationMarker = marker;
            if (result.noInfo) return marker;

            marker.lat = result.lat;
            marker.lng = result.lng;
            marker.clas = result.clas;
            marker.name = result.name;
            marker.code = result.code;
            marker.noImage = result.noImage;
            marker.temp = result.temp;
            marker.request = result.request;
            marker.isDestinationMarker = result.isDestinationMarker;
            marker.ZIndex = marker.getZIndex();

            this.setMarkerData(result, marker);

            if (!result.isDestinationMarker) {
                if (!result.noImage && !result.temp) {
                    marker.id = this.markers.length;
                    this.markers.push(marker); // Add to marker array.
                } else {
                    marker.id = this.noImageMarkers.length;
                    this.noImageMarkers.push(marker); // No image marker.
                }
            }

            var winres = this;
            google.maps.event.addListener(marker, 'click', function (marker) {
                return function () {
                    if (marker.request == true) {
                        // force request to clicked marker.
                        if (!marker.requesting) {
                            marker.requesting = true;
                            var language = winres.localizationService.getLanguage();
                            var reserveLink = true;
                            if (winres.withReserveLink === "false") reserveLink = false;

                            //console.log("[map] requesting marker departure with", marker.code)

                            winres.departureService.searchReservableItems(winres.ReservableItemsSearchParams(marker), reserveLink, language).then(function (departure) {
                                marker.request = false;
                                result = departure.Results[0];
                                //console.log("[map]", marker.code, "found", departure.Results.length, "results.");
                                if (result) {
                                    marker.temp = false;
                                    result.isDeparture = true;
                                    result.departure = result;
                                    winres.noImageMarkers.splice(marker.id, 1); // remove from no image markers array.
                                    winres.markers.push(marker); // add marker to default marker array.
                                    winres.setMarkerData(result, marker); // replace marker contents.
                                } // else console.warn("[map] marker departure is", result, marker.code, marker.name);
                                winres.markerClick(marker);
                            });
                        }
                    } else winres.markerClick(marker);
                };
            }(marker));

            google.maps.event.addListener(marker, 'rightclick', function (marker) {
                return function () {
                    console.log(marker);
                };
            }(marker));
            return marker;
        }
    }, {
        key: 'markerSvgSymbol',
        value: function markerSvgSymbol() {
            var reservable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var LOCATION_PIN = "M12,2L12,2C8.13,2,5,5.13,5,9c0,1.74,0.5,3.37,1.41,4.84c0.95,1.54,2.2,2.86,3.16,4.4c0.47,0.75,0.81,1.45,1.17,2.26 C11,21.05,11.21,22,12,22h0c0.79,0,1-0.95,1.25-1.5c0.37-0.81,0.7-1.51,1.17-2.26c0.96-1.53,2.21-2.85,3.16-4.4 C18.5,12.37,19,10.74,19,9C19,5.13,15.87,2,12,2z M12,11.75c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5 S13.38,11.75,12,11.75z";
            var fillColor = reservable ? "blue" : "#ED1C24";
            return {
                path: LOCATION_PIN,
                fillColor: fillColor,
                strokeColor: "black",
                fillOpacity: 1,
                strokeWeight: 1.3,
                rotation: 0,
                scale: 1.5,
                anchor: { x: 12, y: 24 }
            };
        }
    }, {
        key: 'ReservableItemsSearchParams',
        value: function ReservableItemsSearchParams(marker) {
            var params = {
                DestinationCodes: [marker.code],
                Limit: 1
            };

            if (this.searchCriteria) {
                var startDate = new Date(this.searchCriteria.StartDate);
                var endDate = new Date(this.searchCriteria.EndDate);
                var numAdults = this.searchCriteria.NumAdults;
                var numChildren = this.searchCriteria.NumChildren;
                var numInfants = this.searchCriteria.NumInfants;

                params = Object.assign(params, {
                    StartDate: startDate,
                    EndDate: endDate,
                    NumAdults: numAdults,
                    NumChildren: numChildren,
                    NumInfants: numInfants
                });
            }

            return params;
        }
    }, {
        key: 'setMarkerData',
        value: function setMarkerData(result, marker) {
            var _this13 = this;

            if (result.isDeparture) {
                marker.isDeparture = true;

                var data = result.departure;
                //marker.name = data.Destination.DestinationName;

                // Inject all departure data into marker.
                for (var key in data) {
                    marker[key] = data[key];
                } // Description is needed for word search.
                marker.Description = data.Destination.DestinationName + ";" + data.Destination.DestinationCode + ";" + data.Destination.Group + ";" + data.Destination.PostAddress + ";" + data.Destination.StreetAddress + ";" + data.Destination.Headline;

                var reserveLink = true;
                if (this.withReserveLink === "false") reserveLink = false;

                if (reserveLink == false && result.departure.Departure) {
                    var filterVar = this.$filter;
                    var linkTemplate = this.reservationLinkTemplate;
                    var departureDate = result.departure.Departure.DepartureDate;
                    var arrivalDate2 = result.departure.Departure.ArrivalDate2;
                    linkTemplate = linkTemplate + '/#!/departure/' + result.code + '/' + filterVar("date")(departureDate, 'yyyy-M-d') + '/' + filterVar('date')(arrivalDate2, 'yyyy-M-d') + '/2/0/0"';
                    marker.ReservationLink = linkTemplate;
                }

                /*
                if(this.useSeo==true){
                    var destinationName = "";
                    if(result.departure.Destination)
                        destinationName = result.departure.Destination.DestinationName;
                    else if(result.departure.DestinationInfo)
                        destinationName = result.departure.DestinationInfo.DestinationName;
                      destinationName = destinationName.replace(/ /g, "-").toLowerCase();
                    if(marker.ReservationLink){
                        var link = marker.ReservationLink;
                        var linkParts = link.split("#!/")
                        link = linkParts[0] + "#!/" + destinationName + "/" + linkParts[1];
                        marker.ReservationLink = link;
                    }
                }
                */
            }

            if (result.isHotel) {
                marker.isHotel = true;
                var data = result.departure;
                //if(data.Producer) marker.name = data.Producer.Company; // use result.name is data.Producer is null.

                // Inject all departure data into marker.
                for (var key in data) {
                    marker[key] = data[key];
                }
            }

            if (this.checkIfReservable(marker)) {
                marker.setIcon(this.markerSvgSymbol(true));
            } else {
                var markersInSameSpot = this.findMarkersInSameCoordinates(marker);
                var reservableMarkersInSameSpot = _.some(markersInSameSpot, function (mapMarker) {
                    return _this13.checkIfReservable(mapMarker);
                });

                if (reservableMarkersInSameSpot) {
                    marker.setIcon(this.markerSvgSymbol(true));
                }
            }

            return marker;
        }
    }, {
        key: 'checkIfReservable',
        value: function checkIfReservable(marker) {
            if (!marker.Product) return false;

            var ReservabilityCheckResults = marker.Product.ReservabilityCheckResults;

            if (!ReservabilityCheckResults) return false;

            return !Object.values(ReservabilityCheckResults).includes(false);
        }
    }, {
        key: 'markerClick',
        value: function markerClick(marker) {
            var _this14 = this;

            var info;
            var markersInSameSpot = this.findMarkersInSameCoordinates(marker);

            var template = document.createElement("div");
            template.innerHTML = '<p style="text-align: center"> ' + this.$filter('i18next')('map.results') + ' <b> ' + markersInSameSpot.length + ' </b> </p>';

            var cardList = template.appendChild(document.createElement("div"));
            cardList.className = "map-info-card-list";

            if (!this.markerNameOnly) {
                if (marker.Producer && marker.DestinationInfo) {
                    // Hotel.
                    info = { img: marker.Producer.Images[0].Url,
                        //name:  marker.DestinationInfo.ProductName,
                        name: marker.name,
                        note1: marker.Producer.Note1,
                        note2: marker.Producer.Note2,
                        note3: marker.Producer.Note3,
                        note4: marker.Producer.Note4 };
                    template = this.getHotelInfoWindowTemplate(info);
                } else if (marker.Destination) {
                    // Departure.

                    markersInSameSpot.forEach(function (marker, index) {
                        info = {
                            img: marker.Destination.Images[0],
                            //name: marker.Destination.DestinationName,
                            name: marker.name,
                            description: marker.Destination.Headline,
                            days: _this14.days,
                            price: Math.round(Number(marker.Price)),
                            stars: [],
                            url: marker.ReservationLink,
                            isReservable: _this14.checkIfReservable(marker),
                            priceNote: marker.Product.PriceNote
                        };
                        var stars = marker.Rating;
                        var starArray = [];
                        var i = 0;
                        while (i < 5) {
                            if (i >= stars) starArray.push({ class: "fa fa-star-o unlitStar", type: 0 }); // unlit star.
                            else starArray.push({ class: "fa fa-star litStar", type: 1 }); // lit star.
                            i++;
                        }
                        info.stars = starArray;
                        if (stars > 0) info.hasStars = true;
                        cardList.appendChild(_this14.getDepartureInfoWindowTemplate(info));
                    });
                }
                console.log(template);
                if (info) {
                    if (!this.shouldCloseInfoWindow(marker)) this.openInfoWindow(marker, true, template);
                    return;
                }
            }

            // Name.
            if (!this.shouldCloseInfoWindow(marker)) this.openInfoWindow(marker, false, marker.name);
        }
    }, {
        key: 'findMarkersInSameCoordinates',
        value: function findMarkersInSameCoordinates(marker) {
            var _this15 = this;

            var markers = _.filter(this.markers, function (mapMarker) {
                var mapMarkerLatLng = [mapMarker.lat, mapMarker.lng].toString();
                var markerLatLng = [marker.lat, marker.lng].toString();
                return mapMarkerLatLng == markerLatLng;
            });

            return _.sortBy(markers, function (mapMarker) {
                return _this15.checkIfReservable(mapMarker) ? 0 : 1;
            });
        }
    }, {
        key: 'initMapElement',
        value: function initMapElement() {
            var mapElement = document.createElement("div");
            mapElement.style.width = "100%";
            mapElement.style.height = "100%";
            return mapElement;
        }
    }, {
        key: 'getMapParent',
        value: function getMapParent(clas, index) {
            if (index != null) return document.getElementsByClassName(clas)[index];
            return null;
        }

        // Call this each time map element should be updated.

    }, {
        key: 'updateMap',
        value: function updateMap(parent, element) {
            if (parent.firstChild) {
                parent.removeChild(parent.firstChild);
                parent.appendChild(element);
            } else parent.appendChild(element);
            element.style.display = "block";

            //if(this.mapUpdater)
            //   clearInterval(this.mapUpdater);
        }
    }, {
        key: 'initMap',
        value: function initMap(lat, lng) {
            var _this16 = this;

            // console.log("[map] initializing map. map id='"+this.mapId+"'");

            this.valid = lat != 0 || lng != 0;
            var latLng = { lat: lat, lng: lng };
            if (this.valid == false) console.warn("[map] latitude and longitude is 0.");
            var options = { center: new google.maps.LatLng(lat, lng), zoom: 10 };

            /*var element = document.getElementById("hotel-map");
            if(element) this.map = new google.maps.Map(element, options);*/

            //this.loadingMap = true;
            if (this.valid == true) {
                //
                // console.log("[map] initializing google map. map id='"+this.mapId+"'");
                return new Promise(function (resolve, reject) {
                    // use promise to get timeouted map.
                    _this16.$timeout(function () {
                        if (!_this16.map) {
                            var options = { center: new google.maps.LatLng(lat, lng), zoom: parseInt(_this16.zoomLevel) || 10, disableDefaultUI: _this16.hideControls };
                            //var options = {zoom: parseInt(this.zoomLevel) || 10, disableDefaultUI: this.hideControls};
                            //var mapElement = this.initMapElement();

                            var mapElement = document.getElementById(_this16.mapId);
                            _this16.map = { id: _this16.mapId, mapObject: new google.maps.Map(mapElement, options), mapElement: mapElement };

                            if (_this16.hasCloseButton) _this16.createX(); // X close button.

                            //this.updateMap(document.getElementById(this.map.id), this.map.mapElement);
                            //this.updateMap(this.getMapParent(this.map.id + "-anchor"), this.map.mapElement);
                            //this.updateMap(this.getMapParent(null, this.mapId + "-anchor", this.map.mapElement), this.map.mapElement);
                        } else {
                            _this16.map.mapObject.setCenter(new google.maps.LatLng(lat, lng));
                            _this16.loadingMap = false;
                            // console.log("[map] map center changed. map id='"+this.mapId+"'");
                        }
                        _this16.loadingMap = false;
                        // console.log("%c[map] map initialized.%c", "color: rgb(0,100,0)"); 
                        resolve(_this16.map); // then(map=>this.map=map)
                    });
                });
            }
        }
    }, {
        key: 'createX',
        value: function createX() {
            var X = document.createElement("div");
            X.className = "map-close-x";
            if (this.map.mapElement) this.map.mapElement.appendChild(X);
        }
    }, {
        key: 'convertCoordinates',
        value: function convertCoordinates(arg) {
            var s = arg.substr(arg.length - 1, 1);
            var direction = s === "S" || s === "W" ? -1 : 1;
            var src = arg.substr(0, arg.length - 1);

            //console.log("s", s, "direction", direction, "src", src);

            if (s === "N" || s === "S") {
                var coords = this.DMStoDD(src, true, direction);
                //coords = coords.toFixed(3);
            } else {
                var coords = this.DMStoDD(src, false, direction);
                //coords = coords.toFixed(3);
            }

            return coords;
        }
    }, {
        key: 'DMStoDD',
        value: function DMStoDD(str, latitude, direction) {
            var deglen = latitude ? 2 : 3;
            var secPos = latitude ? 4 : 5;

            var degrees = parseFloat(str.substr(0, deglen));
            var minutes = parseFloat(str.substr(deglen, 2));
            var sec = str.substr(secPos, str.length - secPos);
            sec = sec.length >= 3 ? sec.substr(0, 2) + '.' + sec.substr(2, sec.length - 2) : sec;

            var returnValue = degrees + minutes / 60 + sec / 3600;

            return returnValue * direction;
        }
    }]);

    return WinresReservationMapController;
}();

function gm_authFailure() {
    console.error("Google map authentication failed.");
}

WinresReservationMapController.$inject = ['$scope', '$rootScope', '$timeout', 'productService', 'localizationService', 'destinationService', 'internetClassificationService', 'departureService', '$filter', 'ownerService', '$compile'];

function getTemplate($attrs, $sce) {
    if ($attrs.departureMap === "true") {
        return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'reservationMapDestination';
    }
    return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'reservationMap';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    var normal = require('./winresReservationMap.html');
    var destination = require('./winresReservationMapDestinations.html');
    $templateCache.put('reservationMap', normal);
    $templateCache.put('reservationMapDestination', destination);
}]);

_module3.default.component('winresReservationMap', {
    templateUrl: getTemplate,
    controller: WinresReservationMapController,
    bindings: {
        showTitle: '@', // If true, show name of the destination as a title.
        hotelLocation: '@', // if true, shows the location of hotels instead of departure.
        departureMap: '@', // if true, displays all departures on a map
        reservationLinkTemplate: '@', // when using departure map this is the url the "matkasivu" or "kohdesivu" is, required
        useSpecificClassification: '@', // set internetclassification1 to use in departuremap
        mapLevel: '@', // maximum map level
        useOwnerData: '@', // true / false (default). If true, gets the data to display with getOwnerData();
        onlyFutureDepartures: '@', // true / false (default). If true only dislays future destinations.
        withReserveLink: '@', // true (default)/ false. If false, the reservelink is created in the front end.
        searchCriteria: '<', // Search criteria.
        activeFilters: '<', // Active filters.
        filteredResults: '<',
        zoomLevel: '@', // Optional. Initial map zoom level. 1-20. Higher values possibly work. See Google maps documentation. Whole number (ex: 1: World 5: Landmass/continent 10: City 15: Streets 20: Buildings)
        mapId: '@', // Optional. Id used to get map template element. Default is 'reservation-map'.
        hideControls: '@', // Any value. Hide all map controls if exists.
        watchLatLng: '@', // If should accept $broadcast latitude and longitude changes.
        markerNameOnly: '@', // Any value. Marker info window shows name only if exists.
        infoWindowsOpen: '@', // Any value. Info windows open by default if exists.
        type: '@', // Product filter type. RO = 'room', HY = 'cabin', OK = 'common', null = all.
        hasCloseButton: '@', // X close button at right up corner.
        // Open reservation link in a new tab
        // Reserve links have target="_blank".
        // Default: false
        reserveInNewWindow: '<'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});

// Outer onInit call.
function initMap() {
    var maps = document.getElementsByTagName("winres-reservation-map");
    for (var i = 0; i < maps.length; i++) {
        //angular.element(maps[i]).scope().$$childHead.$ctrl.$onInit();
        angular.element(maps[i]).controller('winresReservationMap').$onInit();
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationMap/winresReservationMap.js
// module id = 414
// module chunks = 2